import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import { useCurrentNamespace } from '@modules/permissions/composables';
import {
  POSTBACKS_PERMISSIONS,
} from '@modules/postbacks/constants';

import type {
  IPostbackUriOption,
} from '../types';
import {
  ADMIN_POSTBACKS_URL_OPTIONS_SAVE_URL,
  AFFILIATE_POSTBACKS_URL_OPTIONS_SAVE_URL,
  POSTBACKS_SAVE_URL_OPTION_MUTATION_KEY,
} from '../constants';

export default function usePostbackUrlOptionDeleteMutation(): IContextMutationResult<
  void,
  Error,
  IPostbackUriOption
> {
  const { fetchDelete } = useRestClient();
  const { isAdminNamespace } = useCurrentNamespace();

  return useContextMutation<void, Error, IPostbackUriOption>({
    mutationKey: [POSTBACKS_SAVE_URL_OPTION_MUTATION_KEY],
    mutationFn: ({
      affiliateId,
      postbackId,
      ...uri_option
    }) => (
      fetchDelete<void>(
        isAdminNamespace.value ? ADMIN_POSTBACKS_URL_OPTIONS_SAVE_URL : AFFILIATE_POSTBACKS_URL_OPTIONS_SAVE_URL,
        {
          permission: POSTBACKS_PERMISSIONS.SHOW,
          urlParams: {
            id: affiliateId,
            postbackId,
            optionId: uri_option.id,
          },
        },
      )
    ),
  });
}
